import api_comm from "./lib";

async function forgotPasswordPut(storemember_guid, password, otp) {
	let params = {
		storemember_guid,
		password,
		otp,
	};

	return api_comm("put", "/auth/api/v2/login/forget", params);
}

export default forgotPasswordPut;
